export default "__VITE_ASSET__Bmr041Nk__"